import Departments from '@/features/departments'
import { listDepartmentsWithRelationsQuery } from '@/queries/department.query'
import { DepartmentFilters } from '@/types/filters/department'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/attendants/departments')({
  component: Departments,
  head: () => ({
    meta: [{
      title: 'Departamentos | Wazai',
    }]
  }),
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(listDepartmentsWithRelationsQuery)
  },
  validateSearch: () => ({}) as DepartmentFilters
})
